import React from 'react';
import { Headphones } from 'lucide-react';
import BrainBoard from '../components/BrainBoard';

// The board itself lives in components/BrainBoard.js, shared with the Accounting and
// Procurement brains. This file is only the words and the people. Owners must match
// the list in netlify/functions/lib/contact-center-brain-db.js — keep the two in step.
const CONFIG = {
  prefix: 'cc',
  section: 'comms',
  sectionLabel: 'Communications',
  title: 'Contact Center Brain',
  icon: Headphones,
  briefFn: 'contact-center-brief',
  chatGuidance: 'This is the customer service side: phone, email, SMS and the unified inbox. Customers here are often mid problem with a perishable order, so answers need to be usable on a live call. Never suggest anything that would send a customer a message on its own.',
  owners: ['Rachael', 'Linda', 'Ashley', 'Greg', 'Claude', 'Carman', 'Mercedes'],
  counterOwners: ['Rachael', 'Linda', 'Claude'],
  ownerRank: ['Rachael', 'Linda', 'Ashley', 'Carman', 'Greg', 'Mercedes', 'Claude'],
  blurb: 'What customers are contacting us about, what we answer, and what is on each person’s plate. The answers the team gives get written down here once, so they stop being re-derived and so the website and the inbox never disagree.',
  docsEmpty: 'No documents stored yet. Reply templates, the answer book, escalation rules and handoffs get added here so they are readable without hunting through email.',
};

export default function ContactCenterBrain() {
  return <BrainBoard config={CONFIG} />;
}
